export const EMPTY_ARRAY = [];

const DEFAULT_GET_VALUE = v => v;

export function isValid(
	options,
	value,
	isDisplay = false,
	getOptionValue = DEFAULT_GET_VALUE
) {
	if (options === null || options === undefined) {
		return true;
	}
	if (!Array.isArray(options)) {
		return true;
	}
	if (value === undefined || value === '') {
		return true;
	}
	if (options === EMPTY_ARRAY && isDisplay) {
		return true;
	}
	if (options.some(opt => getOptionValue(opt) === value)) {
		return true;
	}
	return false;
}
